import { Row } from "react-bootstrap";
import { Label_ts, StyledCol } from "shared/cx-components/cx-components.style";
import { Button } from "../buttons";
import { IconDispatcher } from "shared/Icons";
import { Col } from "reactstrap";
import { useTranslation } from "react-i18next";

interface LabelDisplayProps {
    id: string;
    children: React.ReactNode;
    icon: string;
    label: string;
    showHide?: boolean;
    onHide: () => void;
}
const LabelDisplay: React.FC<LabelDisplayProps> = ({ id, children, icon, label, showHide = false, onHide }) => {
    const { t } = useTranslation();

    return <Row key={id} style={{ minHeight: "50px" }}>
        <StyledCol xs={4} className="p-2 ps-3">
            <div>{IconDispatcher(icon)}</div>
            <Label_ts size={14} className="ps-2">
                {t(label)}
            </Label_ts>
            {showHide && (
                <Button variant="light-link" size="s" title={t("HIDE")} id="eyeButton" onClick={onHide}>
                    <div> {IconDispatcher("HIDE_EYE")}</div>
                </Button>
            )}
        </StyledCol>
        <Col xs={8}>
            {children}
        </Col>
    </Row>
}
export default LabelDisplay;